import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
import { signin } from './api';
//import { history } from 'app/history';
import LocalStorage from 'utilities/localStorage';

const initialState = {
  loading: false,
  token: '',
  user: null
};

const actions = {
  LOGIN: 'login/LOGIN'
};

export const login = createAsyncThunk(actions.LOGIN, async (payload) => {
  const response = await signin(payload);
  console.log(response);
  if (response?.token) {
    const { token, user_details } = response;
    let newUser = {
      token,
      user_details
    };

    LocalStorage.setItem('gatepass_user', JSON.stringify(newUser));
  }

  return response;
});

export const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    resetLoginDetails: (state) => {
      state.token = '';
      state.user = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
      })
      .addCase(login.fulfilled, (state, action) => {
        const { token, message: msg, msg: msg1, user } = action.payload;
        state.loading = false;
        state.token = token;
        state.user = user;

        if (token) {
          message.success(msg);
        } else {
          message.error(msg1);
          localStorage.clear();
        }
      })
      .addCase(login.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });
  }
});

export const { resetLoginDetails } = loginSlice.actions;

export const logout = () => (dispatch) => {
  localStorage.clear();
  dispatch(resetLoginDetails());
  // message.success('Logged out successfully');
  // history.push('/login');
};

export default loginSlice.reducer;
